let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dBE6l")).then(() => parcelRequire('45UrY'));